export default "__VITE_ASSET__Dt38ELdN__"